import { ControlValueAccessor } from '@angular/forms';

export class NbValueAccessor<T> implements ControlValueAccessor {
  private innerValue: T;

  private changed = new Array<(value: T) => void>();

  get value(): T {
    return this.innerValue;
  }

  set value(value: T) {
    this.innerValue = value;
    this.changed.forEach(f => f(value));
  }

  writeValue(value: T) {
    this.value = value;
  }

  registerOnChange(fn: (value: T) => void) {
    this.changed.push(fn);
  }

  registerOnTouched() {}
}
